export var IdStatValueType;
(function (IdStatValueType) {
    IdStatValueType["Percentage"] = "percentage";
    IdStatValueType["Time"] = "time";
})(IdStatValueType || (IdStatValueType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdStatValueType.ts
// module id = 928
// module chunks = 3